import { ContentStepForm } from '../../../schemas/contentStepSchema';
import { Program } from '../../../types/program';
import { AllowedFileTypes } from '../../../types/programModulesAndContents';
import { getFileName } from '../../getFileName';

export const formatContentStepValues = (program: Program): ContentStepForm => {
  return {
    modules: program.modules
      .map(module => ({
        moduleId: module.id,
        title: module.title,
        description: module.description || undefined,
        order: module.order,
        contents: module.contents
          .map(content => ({
            contentId: content.id,
            title: content.title,
            order: content.order,
            type: content.type as AllowedFileTypes,
            directory: content.directory || undefined,
            instructorId:
              content.instructors[0]?.id || program.instructors[0]?.id,
            neutralThumb: {
              preview: content?.thumbVideo?.neutral,
              name: null,
              file: null,
            },
            femaleThumb: {
              preview: content?.thumbVideo?.female,
              name: null,
              file: null,
            },
            maleThumb: {
              preview: content?.thumbVideo?.male,
              name: null,
              file: null,
            },
            tags: content.tags || [],
            description: content.description || undefined,
            file: {
              fileUrl: content.value,
              fileName: getFileName(content.value),
            },
          }))
          .sort((a, b) => a.order - b.order),
      }))
      .sort((a, b) => a.order - b.order),
  };
};
